/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { appSyncGraphQLApi } from '../../app/smorgAppSyncGraphQLApi';

export enum StaleResourceType {
  PlannerWeek = 'PlannerWeek',
  Programme = 'Programme',
  SmorgBoard = 'SmorgBoard',
  SharedContentBoard = 'SharedContentBoard',
}

export interface ResourceUpdateRecord {
  resourceType: StaleResourceType;
  resourceID: string;
  updatedAt: string;
}

export interface StaleResourceDetectionState {
  resourcesToRefresh: Array<ResourceUpdateRecord>;
}

const initialState: StaleResourceDetectionState = {
  resourcesToRefresh: [],
};

export const staleResourceDetectionSlice = createSlice({
  name: 'staleResourceDetection',
  initialState,
  reducers: {
    resourceLastUpdatedAvailable: (
      state,
      action: PayloadAction<ResourceUpdateRecord>,
    ) => {
      const { resourceType, resourceID } = action.payload;
      const newResourcesToRefresh = state.resourcesToRefresh.filter(
        (r) => r.resourceType !== resourceType || r.resourceID !== resourceID,
      );
      state.resourcesToRefresh = [...newResourcesToRefresh, action.payload];
    },
  },
  selectors: {
    areResourcesStaleSelector: (state, resourceType, currentResources) => {
      return currentResources
        .filter(Boolean)
        .some((currentResource: { id: string; updatedAt: string }) => {
          const resourceUpdateRecord = state.resourcesToRefresh.find(
            (r) =>
              r.resourceType === resourceType &&
              currentResource.id === r.resourceID,
          );
          if (!resourceUpdateRecord) {
            return false;
          }
          return (
            resourceUpdateRecord.updatedAt.localeCompare(
              currentResource.updatedAt,
            ) > 0
          );
        });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(appSyncGraphQLApi.util.resetApiState, (state) => {
      state.resourcesToRefresh = [];
    });
  },
});

export const { resourceLastUpdatedAvailable } =
  staleResourceDetectionSlice.actions;

export const { areResourcesStaleSelector } =
  staleResourceDetectionSlice.selectors;

export default staleResourceDetectionSlice.reducer;
